import i18next from "i18next";
import { PersistantStorage } from "../Utils/LocalStorage";
import { createLocalizationService } from "./createLocalizationService";

const service = createLocalizationService({
  namespace: "translation",
  cachePrefix: "Locale",
});

export const LocalizationService = {
  getLocale: service.getLocale,
  changeLanguage: async (locale, tenantId) => {
    const modules = service.getList(locale);
    let allModules = service.getAllList();
    if (allModules.length === 0) {
      allModules.push('dfsweb-common');
    }
    const uniqueModules = allModules.filter(
      (module) => !modules.includes(module)
    );
    await service.getLocale({ modules: uniqueModules, locale, tenantId });
    PersistantStorage.set("WebApp.Employee.locale", locale);
    i18next.changeLanguage(locale);
    document.documentElement.lang = locale.split("_")[0];
  },
  updateResources: (messages, locale = "en_IN") => {
    if (locale.indexOf("_IN") === -1) {
      locale += "_IN";
    }
    service.updateResources(messages, locale);
  },
};
